import { VisualGoalComparison } from 'fitify-ui-onboarding/src/components/Paywall/VisualGoalComparison/VisualGoalComparison'

import type { GoalComparisonFunnel } from './GoalComparison.Utils'
import { useGoalComparison } from './useGoalComparison'

type Props = {
  funnel: GoalComparisonFunnel
}

export const GoalComparison = ({ funnel }: Props) => {
  const { fitnessLevelTitle, now, goal } = useGoalComparison({ funnel })

  return (
    <VisualGoalComparison
      fitnessLevelTitle={fitnessLevelTitle}
      now={now}
      goal={goal}
    />
  )
}
